import React from "react";
import { Link } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import HeaderBox from "../reuseableComponents/headerBox/HeaderBox";
import { faFlag } from "@fortawesome/free-solid-svg-icons";
import { useQuery } from "@apollo/client";

import ErrorHandler from "../reuseableComponents/ErrorHandler";
import SkeletonLoader from "../reuseableComponents/loaders/SkeletonLoader";
import { GET_APP_MENU } from "../../queries/menuQrys/baseWLMenuQrys";
import MenuCard from "../reuseableComponents/MenuCard";

const menuIcons = {
  IPS_DEF: faFlag
};

const PublicIndex = () => {
  const { loading, error, data } = useQuery(GET_APP_MENU, { variables: { menu: "PUBLIC" } });
  if (loading)
    return (
      <>
        <Row>
          <Col>
            <HeaderBox id={"gray-primary"} cypressid='publicHomePage'>
              <h3 style={{ color: "#fff" }}>Public Reports</h3>
            </HeaderBox>
          </Col>
        </Row>
        <Row>
          <Col>
            <SkeletonLoader width='100%' />
          </Col>
        </Row>
      </>
    );

  if (error) {
    return (
      <>
        <Row>
          <Col>
            <Link to='/' className='m-2 hyperlink'>
              Home
            </Link>
            <Link to='/secure/module-index' className='m-2 hyperlink'>
              Modules
            </Link>
          </Col>
        </Row>
        <Row>
          <Col>
            <HeaderBox id={"gray-primary"} cypressid='publicHomePage'>
              <h3 style={{ color: "#fff" }}>Public Reports</h3>
            </HeaderBox>
          </Col>
        </Row>
        <Row>
          <Col>
            <ErrorHandler error={error} />
          </Col>
        </Row>
      </>
    );
  }

  return (
    <>
      <Row>
        <Col>
          <HeaderBox id={"gray-primary"} cypressid='publicHomePage'>
            <h3 style={{ color: "#fff" }}>Public Reports</h3>
          </HeaderBox>
        </Col>
      </Row>
      <Row>
        <Row>
          {data.getAppMenu.map((module) => (
            <Col md={4} key={module.value}>
              <MenuCard icon={menuIcons[module.value]} module={module.value} route={module.route} name={module.label} />
            </Col>
          ))}
        </Row>
      </Row>
    </>
  );
};

export default PublicIndex;
